/** 全ログイン画面共通案内（文言のみ。HTML は login-policy.js と揃える） */

export const INTERNAL_LOGIN_POLICY = {
  title: "naturenix 社員の方",
  lines: [
    "セキュリティ強化のため、ID/パスワードでの直接ログインは廃止しました（2026年7月〜）。",
    "admin.naturenix.jp の「Google でログイン」から、@naturenix.co.jp のアカウントでサインインしてください。",
    "No.1さまにもアカウントをお持ちの出向者の方: dash・社内ツールは Google（@naturenix.co.jp）。No.1 受注だけ別 PW です。",
  ],
};

export const PARTNER_LOGIN_POLICY = {
  title: "No.1さま（@number-1.co.jp）",
  lines: [
    "Google ログインは使えません。メール + パスワードで admin.naturenix.jp に入ってください。",
    "パスワード不明: admin の「パスワードをお忘れの方」から @number-1.co.jp で再発行。届かない場合は naturenix 担当へ。",
  ],
};

export const CAMPAIGN_LOGIN_POLICY = {
  title: "ログインについて",
  lines: [
    "ここは EC-700 現場・No.1さま向けです。受注/dash は admin.naturenix.jp からログインしてください。",
    "naturenix 社員は @naturenix.co.jp の Google ログイン（旧 ID/PW 不可）。",
  ],
};

export const REDIRECT_LOGIN_POLICY = {
  title: "ログイン方法（2026年7月〜）",
  lines: [
    "naturenix 社員: admin.naturenix.jp で @naturenix.co.jp の Google ログイン（旧 ID/PW 不可）。",
    "No.1さま: 同ページで @number-1.co.jp のメール + パスワード。再発行は naturenix 担当へ連絡。",
  ],
};

export type LoginPolicy = { title: string; lines: string[] };

const LOGIN_ERROR_MAP: Record<string, string> = {
  "Invalid credentials":
    "メールアドレスまたはパスワードが正しくありません。入力ミス（例: @gmail.com の綴り）がないかご確認ください。",
  "Internal users must use Google login":
    "naturenix 社員の方は上の「Google でログイン」をご利用ください（メール+パスワードは使えません）。",
  "Missing email or password": "メールアドレスとパスワードを入力してください。",
  "Invalid code": "確認コードが正しくありません。",
  "Invalid challenge": "認証の有効期限が切れました。もう一度ログインしてください。",
};

/** API のエラーレスポンス（JSON の detail や生テキスト）をユーザー向けの文言に変換 */
export function loginErrorMessage(raw: string): string {
  const s = (raw || "").trim();
  if (!s) return "ログインに失敗しました。しばらくしてからお試しください。";

  try {
    const parsed = JSON.parse(s) as { detail?: string | unknown[] };
    const d = parsed?.detail;
    if (typeof d === "string") return mapLoginErrorDetail(d) ?? d;
    if (Array.isArray(d)) {
      const parts = d
        .map((x) => (typeof x === "object" && x && "msg" in x ? String((x as { msg: string }).msg) : String(x)))
        .filter(Boolean);
      if (parts.length) return parts.join(" ");
    }
  } catch {
    /* 生テキスト */
  }
  return mapLoginErrorDetail(s) || s;
}

function mapLoginErrorDetail(d: string): string | undefined {
  if (LOGIN_ERROR_MAP[d]) return LOGIN_ERROR_MAP[d];
  if (d.includes("expired") || d.includes("Code expired")) {
    return "確認コードの有効期限が切れました。再送信してください。";
  }
  if (d.includes("Invalid credentials")) return LOGIN_ERROR_MAP["Invalid credentials"];
  if (d.includes("Internal users must use Google")) return LOGIN_ERROR_MAP["Internal users must use Google login"];
  return undefined;
}
